import { React, useState } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ListGroup, ListGroupItem, Button } from 'react-bootstrap';
import BasicTooltip from '../Tooltip/BasicTooltip';
import '../Filters/Filters.scss';
import { CiFilter } from 'react-icons/ci';
import MultiSelectFilter from '../Filters/MultiSelectFilter';
import { CiCircleRemove } from "react-icons/ci";

library.add(fal);

const SortDocList = ({ sortSettings, setIsFetching, setSortValue, defaultSortValue, onSortingChanged, tagOptions, tagSelectedValues, onSelect, showFilter }) => {
  const [sortBy, setSortBy] = useState(sortSettings);
  const [showFilterPopover, setShowFilterPopover] = useState(false);
  const [showWithoutTags, setShowWithoutTags] = useState(false);
  const tagOptionList = tagOptions?.map((item) => ({ label: item?.name, value: item?.id, name: item?.name }));

  const onSort = (field) => {
    setIsFetching(true);
    if (field.active && field.direction === 'DESC') {
      field.direction = 'ASC';
    } else if (field.active && field.direction === 'ASC') {
      field.direction = 'DESC';
      field.active = false;
    } else if (!field.active) {
      field.active = true;
    }
    let sort = { ...sortBy };
    const sort_by = Object.keys(sortBy)
      .filter((field, index) => sortBy[field].active)
      .map((f) => `${f}${sortBy[f].direction === 'ASC' ? '+' : '-'}`);
    setSortValue(sort_by);
    setSortBy(sort);
    if (onSortingChanged) {
      onSortingChanged();
    }
  };

  const handleResetSorting = () => {
    setIsFetching(true);
    setSortValue(defaultSortValue);
    setSortBy(sortSettings);
    if (onSortingChanged) {
      onSortingChanged();
    }
  }

  const handleResetFilter = () => {
    onSelect([], {});
    setShowWithoutTags(false);
  }

  const handleWithoutTagsToggle = () => {
    const newValue = !showWithoutTags;
    setShowWithoutTags(newValue);
    // You can add additional logic here to handle without tags filter
    if (onSortingChanged) {
      onSortingChanged();
    }
  }

  return (
    <ListGroup horizontal>
      {Object.keys(sortBy).map((field, i) => (
        <ListGroupItem
          key={`sort-${i}`}
          className='flex-fill'
          style={{ textAlign: 'center' }}
        >
          <Button
            variant='outline-secondary'
            onClick={() => onSort(sortBy[field])}
            active={sortBy[field].active && true}
          >
            {sortBy[field].label}
            {sortBy[field].active && (
              <FontAwesomeIcon
                icon={[
                  'fal',
                  `${sortBy[field].direction === 'DESC'
                    ? 'caret-down'
                    : 'caret-up'
                  }`,
                ]}
                style={{ fontSize: '1.5rem', marginLeft: '10px' }}
              ></FontAwesomeIcon>
            )}
          </Button>
        </ListGroupItem>
      ))}
      <ListGroupItem className="flex-fill text-center">
        <BasicTooltip text="Reset sorting" placement="top">
          <Button variant="outline-secondary" onClick={handleResetSorting}>
            Reset
          </Button>
        </BasicTooltip>
      </ListGroupItem>
      {showFilter && <ListGroupItem className="flex-fill text-center">
        <div className="position-relative d-inline-block">
          <div>
            <div className='d-flex justify-content-center align-items-center'>
              <BasicTooltip text="Filter by Tags" placement="top" show={!showFilterPopover ? undefined : false}>
                <div className="position-relative">
                  <CiFilter
                    style={{
                      fontSize: '38px',
                      cursor: 'pointer',
                    }}
                    onClick={() => setShowFilterPopover(!showFilterPopover)}
                  />
                  {showFilterPopover && (
                    <div className="sort-filter-popover filters-popover">
                      <div className="filters-popover-header">
                        <span>Filter by Tags</span>
                        <button
                          type="button"
                          className="filters-popover-close"
                          onClick={() => setShowFilterPopover(false)}
                        >
                          ×
                        </button>
                      </div>

                      <div className="doc-filter-list">
                        {/* <div className="mb-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <label className="form-check-label mb-0" style={{ fontSize: '0.9rem' }}>
                              Show records without tags
                            </label>
                            <div className="form-check form-switch mb-0">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={showWithoutTags}
                                onChange={handleWithoutTagsToggle}
                                style={{ cursor: 'pointer' }}
                              />
                            </div>
                          </div>
                        </div> */}
                        <MultiSelectFilter
                          label=""
                          options={tagOptionList}
                          value={tagSelectedValues}
                          onChange={onSelect}
                          placeholder="Select tags"
                          countLabel='tag'
                        />

                      </div>
                    </div>
                  )}
                </div>
              </BasicTooltip>
              <BasicTooltip text="Reset filter" placement="top">
                <div>
                  {tagSelectedValues?.length > 0 && (<CiCircleRemove
                    style={{
                      fontSize: '20px',
                      cursor: 'pointer',
                      marginLeft: '8px'
                    }}
                    onClick={handleResetFilter}
                  />)}
                </div>
              </BasicTooltip>
            </div>
            {tagSelectedValues?.length > 0 && (
              <span
                className='filter-badge-count'
              >
                {' '}
              </span>
            )}
          </div>
        </div>
      </ListGroupItem>}
    </ListGroup>
  );
};

export default SortDocList;
